/**
 * `#ai` — `template.html` dòng 895–946.
 *
 * Số phần tử là số ĐO, không phải lựa chọn: 3 card loại agent (:905-915), 2 card năng lực
 * (:920-926), 6 card agent mẫu (:932-937). Đổi số là đổi thiết kế — `copy.test.ts` canh.
 */

/** Một loại agent. `icon` khai union tại nguồn để chỗ dùng khỏi ép kiểu và gõ sai là lỗi ở đây. */
interface AgentType {
  readonly icon: 'globe' | 'user-round-cog' | 'users-round';
  readonly title: string;
  readonly body: string;
}

interface Capability {
  readonly icon: 'infinity' | 'user-plus';
  readonly title: string;
  readonly body: string;
}

interface SampleAgent {
  readonly initials: string;
  readonly name: string;
  readonly body: string;
  readonly chips: readonly string[];
}

const types: readonly AgentType[] = [
  {
    icon: 'globe',
    title: 'Public Agent',
    body: 'Dùng chung cho cả công ty — một trợ lý ai cũng gọi được, với cùng một bộ nguồn dữ liệu và quy tắc.',
  },
  {
    icon: 'user-round-cog',
    title: 'Alias Agent',
    body: 'Trợ lý riêng của từng nhân viên, thừa hưởng đầy đủ và đúng bằng quyền truy cập của chính người đó — không hơn, không kém.',
  },
  {
    icon: 'users-round',
    title: 'Agent phòng ban',
    body: 'Bản chất là Public Agent nhưng có whitelist — chỉ người trong danh sách được sử dụng, để trợ lý tài chính, nhân sự hay pháp chế nằm gọn trong phòng ban.',
  },
];

const capabilities: readonly Capability[] = [
  {
    icon: 'infinity',
    title: 'Connector & Skill không giới hạn',
    body: 'Bất kỳ hệ thống bên ngoài nào có API đều kết nối được, và số lượng skill cũng không giới hạn — khả năng của agent mở rộng theo doanh nghiệp thay vì cố định từ ngày đầu.',
  },
  {
    icon: 'user-plus',
    title: 'Vai trò Guest',
    body: 'Đưa đối tác, nhà thầu vào workspace với vai trò Guest. Member thêm họ vào channel hoặc group để cùng làm việc — và Guest cũng chat được với agent trong chính channel/group đó.',
  },
];

const samples: readonly SampleAgent[] = [
  {
    initials: 'HR',
    name: 'Hera HR',
    body: 'Chính sách, nghỉ phép, checklist onboarding.',
    chips: ['HRIS', 'Docs'],
  },
  {
    initials: 'AD',
    name: 'Atlas DevOps',
    body: 'Pipeline, deploy, dòng thời gian sự cố.',
    chips: ['CI/CD', 'GitLab'],
  },
  {
    initials: 'PS',
    name: 'Pitch Sales',
    body: 'Sức khoẻ pipeline, tóm tắt khách hàng, việc cần theo.',
    chips: ['CRM'],
  },
  {
    initials: 'CR',
    name: 'Clio Research',
    body: 'Rà soát thị trường và tóm tắt có trích nguồn.',
    chips: ['Web'],
  },
  {
    initials: 'FE',
    name: 'Forge Engineer',
    body: 'Ghi chú review code, ticket, bản nháp kỹ thuật.',
    chips: ['Repo', 'Linear'],
  },
  {
    initials: 'QA',
    name: 'Quill Analyst',
    body: 'Dashboard, trả lời bằng SQL, khuyến nghị go/no-go.',
    chips: ['SQL', 'Snowflake'],
  },
];

export const aiAgents = {
  eyebrow: 'AI Agents & Skills',
  heading: 'Số lượng agent không giới hạn, phân quyền đúng như cách doanh nghiệp vận hành.',
  lead: 'Doanh nghiệp triển khai bao nhiêu agent tuỳ nhu cầu — dùng chung toàn công ty, riêng từng nhân viên, hoặc theo phòng ban — và mọi agent đều ở ngay trong luồng trò chuyện của đội, để một câu trả lời trở thành task mà không cần rời cuộc hội thoại.',
  types,
  capabilities,
  samplesEyebrow: 'Ví dụ agent trong workspace demo',
  samples,
  skillsLabel: 'Skills',
  skillsBody:
    'Kỹ năng tái sử dụng mang theo quy trình, cách diễn đạt và giới hạn của bạn — viết một lần, dùng cho mọi loại agent.',
};
